/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Error_GenericInputs */



/**
* | output |
* | --- |
* | "Unable to load API keys. Please try again." |
*
* @param {Options_Api_Keys_Error_GenericInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_error_generic = /** @type {((inputs?: Options_Api_Keys_Error_GenericInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Error_GenericInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de charger les clés API. Veuillez réessayer.")
	if (locale === "de") return /** @type {LocalizedString} */ ("API-Schlüssel konnten nicht geladen werden. Bitte versuchen Sie es erneut.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile caricare le chiavi API. Riprova.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось загрузить ключи API. Пожалуйста, попробуйте еще раз.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pueden cargar las claves API. Inténtalo de nuevo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("API密钥加载失败，请重试。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("APIキーを読み込めません。もう一度お試しください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एपीआई कुंजी लोड करने में असमर्थ। कृपया पुनः प्रयास करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não foi possível carregar as chaves da API. Tente novamente.")
	return /** @type {LocalizedString} */ ("Unable to load API keys. Please try again.")
});